import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./features/userSlice";
import stepReducer from "./features/stepSlice";
import drawerReducer from "./features/drawerSlice";

export default configureStore({
  reducer: {
    user: userReducer,
    step: stepReducer,
    drawer: drawerReducer,
  },
});
